import { ReactElement } from "react";
import {
  LuChartColumnBig,
  LuFileText,
  LuReceipt,
  LuUsers,
  LuUserCheck,
  LuClock,
} from "react-icons/lu";
import SidebarMenu, { MenuItem } from "../ui/sidebar-menu";
import { ClubManagementMenuItem } from "./constants";
import { UserRole } from "../../api/types";

type ClubManagementMenuProps = {
  onSelect?: (item: ClubManagementMenuItem) => void;
};

const MENU_ITEMS: MenuItem<ClubManagementMenuItem>[] = [
  {
    item: ClubManagementMenuItem.STATISTICS,
    icon: <LuChartColumnBig />,
    labelKey: "club_management.menu.statistics",
  },
  {
    item: ClubManagementMenuItem.USERS,
    icon: <LuUsers />,
    labelKey: "club_management.menu.users",
  },
  {
    item: ClubManagementMenuItem.BOOKINGS,
    icon: <LuFileText />,
    labelKey: "club_management.menu.bookings",
  },
  {
    item: ClubManagementMenuItem.USER_BOOKINGS,
    icon: <LuUserCheck />,
    labelKey: "club_management.menu.user_bookings",
  },
  {
    item: ClubManagementMenuItem.RECEIPTS,
    icon: <LuReceipt />,
    labelKey: "club_management.menu.receipts",
  },
  {
    item: ClubManagementMenuItem.UNPAID_HOURS,
    icon: <LuClock />,
    labelKey: "club_management.menu.unpaid_hours",
  },
];

const ClubManagementMenu = ({ onSelect }: ClubManagementMenuProps): ReactElement => (
  <SidebarMenu titleKey="club_management.menu.title" menuItems={MENU_ITEMS} onSelect={onSelect} />
);

export default ClubManagementMenu;
